import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { authService } from '../services/AuthService';
import TurnstileWidget, { isCaptchaEnabled } from '../components/TurnstileWidget';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaKey, setCaptchaKey] = useState(0);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authService.forgotPassword({ email, captchaToken });
      navigate('/reset-password', { state: { email } });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Något gick fel');
      setCaptchaToken('');
      setCaptchaKey(k => k + 1);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-teal-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-teal-700 mb-4">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Glömt lösenord?</h1>
          <p className="text-gray-500 mt-1">Ange din e-postadress så skickar vi en återställningslänk</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 space-y-5">
          {error && (
            <div className="bg-red-50 text-red-700 px-4 py-3 rounded-xl text-sm border border-red-100">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="forgot-email" className="block text-sm font-medium text-gray-700 mb-1.5">E-postadress</label>
            <input
              id="forgot-email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
              placeholder="din@epost.se"
            />
          </div>

          <TurnstileWidget key={captchaKey} onToken={setCaptchaToken} />

          <button
            type="submit"
            disabled={loading || (isCaptchaEnabled() && !captchaToken)}
            className="w-full py-2.5 px-4 bg-teal-700 hover:bg-teal-800 text-white font-medium rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Skickar...' : 'Skicka återställningslänk'}
          </button>

          <p className="text-center text-sm text-gray-500">
            <Link to="/login" className="text-teal-700 hover:text-teal-800 font-medium">
              Tillbaka till inloggning
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
